import {FormField} from "../types/enums";

export const singleFormInputsData = {
  title: "Nový účastník",
  feeTypeData: {
    label: "Srazový poplatek",
    loadingText: "Načítání srazových poplatků...",
    inputType: "select",
    name: FormField.FeeType,
    requiredErrorMessage: "Srazový poplatek je povinný.",
    id: "feeTypeId",
    placeholder: "Nejprve zvolte typ poplatku",
  },
  basicData: [
    {
      label: "Jméno",
      inputType: "text",
      name: FormField.Name,
      id: "name",
      requiredErrorMessage: "Jméno je povinné.",
      validationPatternValue: /^.{2,}$/,
      errorMessage: "Jméno musí obsahovat alespoň dva znaky.",
    },
    {
      label: "Příjmení",
      inputType: "text",
      name: FormField.LastName,
      id: "lastName",
      requiredErrorMessage: "Příjmení je povinné.",
      validationPatternValue: /^.{2,}$/,
      errorMessage: "Příjmení musí obsahovat alespoň dva znaky.",
    },
    {
      label: "E-mail",
      inputType: "email",
      name: FormField.Email,
      requiredErrorMessage: "E-mail je povinný.",
      validationPatternValue: /^\S+@\S+$/i,
      errorMessage: "Vyplňte platný e-mail.",
    },
    {
      label: "Telefonní číslo",
      inputType: "tel",
      name: FormField.PhoneNumber,
      requiredErrorMessage: "Telefonní číslo je povinné.",
      validationPatternValue:
        /^\+?\d{1,4}[\s.-]?\(?\d{1,4}\)?[\s.-]?\d{1,4}[\s.-]?\d{1,9}$/,
      errorMessage: "Vyplňte platné telefonní číslo.",
    },
    {
      label: "Adresa bydliště",
      inputType: "text",
      name: FormField.Address,
      requiredErrorMessage: "Adresa je povinná.",
    },
    {
      label: "Datum narození",
      inputType: "date",
      name: FormField.BirthDate,
      requiredErrorMessage: "Datum narození je povinné.",
      max: new Date().toISOString().split("T")[0],
    },
    {
      label: "Číslo OP nebo pasu",
      inputType: "text",
      name: FormField.IdNumber,
      descriptionMessage:
        "U účastníka mladšího 15-ti let, občana ČR není vyžadováno. Do pole v tomto případě vyplňte 'nemá'.",
      validationPatternValue: /^(\d{9}|[A-Z0-9]{8}|nemá|nema)$/i,
      errorMessage: "Vyplňte platné číslo OP nebo pasu.",
    },
    {
      label: "Číslo průkazu KČT, KST, PTTK",
      inputType: "text",
      name: FormField.MembershipNumber,
      requiredErrorMessage: "Číslo průkazu je povinné.",
      validationPatternValue: /^\d{10}$/,
      errorMessage: "Číslo průkazu musí mít 10 číslic.",
    },
  ],
  accommodationsData: [
    {
      label: "Název ubytování",
      inputType: "text",
      name: FormField.NameOfAccommodation,
      id: "customAccommodationName",
      requiredErrorMessage: "Název ubytování je povinný.",
      descriptionMessage:
        "Uveďte název zařízení, které jste si individuálně zajistili.",
    },
    {
      label: "Místo ubytování",
      inputType: "text",
      requiredErrorMessage: "Místo ubytování je povinné.",
      name: FormField.PlaceOfAccommodation,
      id: "customAccommodationAddress",
      descriptionMessage:
        "Uveďte místo zařízení, které jste si individuálně zajistili.",
    },
  ],
  accommodationTypeData: {
    label: "Typ ubytování",
    inputType: "select",
    name: FormField.AccommodationType,
    requiredErrorMessage: "Typ ubytování je povinný.",
    id: "accommodationType",
    placeholder: "Nejprve zvolte typ ubytování",
  },
  stayDatesData: {
    label: "Dny pobytu",
    inputType: "checkbox",
    name: FormField.StayDatesMultiple,
    requiredErrorMessage: "Dny pobytu jsou povinné.",
  },
  additionalServicesData: {
    label: "Doplňkové služby",
    inputType: "checkbox",
    name: "additionalServices",
  },
};
